import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import InputBase from '@material-ui/core/InputBase';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { isEmpty, DeepCopy, DicVal} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import { imageopen, setimagelist } from '../modules/imagedlgstore';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField';

//---------------------------------------------------------------------
//  EntryForm ImageList
//---------------------------------------------------------------------
//  deleteurl:画像削除代替URL
//---------------------------------------------------------------------
export default function EntryImages(props) {

    const formlock = useSelector(state => state.form.entryformlock);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const [images, setimage] = useState([]);
    const [kindlist, setkindlist] = useState([]);
    const dispatch = useDispatch();
    const imageDataKey = Array.isArray(props.dataRef.current)
        ? props.dataRef.current.map((img) => `${img.fullname ?? img.filename ?? ""}:${img.kind ?? ""}:${img.note ?? ""}`).join("|")
        : "";

    useEffect(() => {
        let list = props.dataRef.current;
        if (!isEmpty(list)) {
            setimage([...list]);
        } else {
            setimage([]);
        }
    }, [props.code, imageDataKey, formstatus]);

    useEffect(() => {
        if (!isEmpty(props.imgkindlist)) {
            setkindlist(props.imgkindlist);
        }
    }, [props.imgkindlist]);

    useEffect(() => {
        if (isEmpty(DicVal(menuinfo, "otherctrls", null))) return;
        var list = DicVal(menuinfo.otherctrls, "IMGKIND", null);
        if (list === null) return;
        var kinds = [];
        kinds.push({ label: '', value: '' })
        for (let i = 0; i < list.length; i++) {
            var ar = list[i].split(":");
            kinds.push({ value: ar[0], label:ar[1]});
        }
        setkindlist(kinds);
    }, [menuinfo]);

    function setimages(images) {
        setimage([...images]);
        props.dataRef.current = [...images];
    }

    function imagedelete(filename) {
        if (formstatus === 'ENTRY FORM') {
            let msg = "「" + filename + "」をクラウド上から削除します。よろしいですか？";
            props.fnc.current.confmsg(msg, () => deleteFile(0, filename));
        } else {
            //v1.4
            let msg = "「" + filename + "」を削除します。よろしいですか？";
            props.fnc.current.confmsg(msg, execute);
        }
        function execute() {
            let newfile = images.filter(function (file) {
                return file.filename !== filename;
            })
            setimages(newfile);
            dispatch(setimagelist(newfile));
            if (newfile.length === 0) {
                props.dataRef.current = null;
                dispatch(setimagelist([]));
                if (!isEmpty(props.rerender)) props.rerender();
            }
        }
    }
    //File Delete
    function deleteFile(type, filename) {
        let urlctrl = props.controller;
        if (urlctrl.indexOf(":") !== -1) urlctrl = props.controller.split(":")[0];
        let url = urlctrl + "/FileDelete";
        if (!isEmpty(props.deleteurl)) {
            url = props.deleteurl;
        }
        props.fnc.current.postaxios(url, { "code": props.code, "subkey": filename, "controller":props.controller },
            {
                onSuccess: function (data) {
                    let newfile = images.filter(function (file) {
                        return file.filename !== filename;
                    })
                    setimages(newfile);
                    dispatch(setimagelist(newfile));
                    if (newfile.length === 0) {
                        props.dataRef.current = null;
                        dispatch(setimagelist([]));
                        if (!isEmpty(props.rerender)) props.rerender();
                    }
                    //props.fnc.current.success();
                    props.fnc.current.wait(false);
                },
                errmsg: "ファイル削除に失敗しました"
            }
        )
    }
    function imagedownload(filename) {
        let fullname = images.find(e => e.filename === filename).fullname;
        let params = {
            "filename": fullname,
            "dnfile": filename
        }
        props.fnc.current.filedownload("common/FileDownload", params);
    }

    function ImageDialog(image) {
        dispatch(imageopen({ images: images, default: image.filename }));
    }
    //image種別
    function imagekindChange(e, target) {
        if (isEmpty(images)) return;
        var newimage = images.map(function (img) {
            if (img.filename === target.filename) {
                return { ...img, kind: e.target.value}
            } else {
                return img;
            }
        });
        setimages(newimage);
    }
    //image備考
    function imagenoteChange(e,target) {
        var newimage = images.map(function (img) {
            if (img.filename === target.filename) {
                return { ...img, note: e.target.value }
            } else {
                return img;
            }
        });
        setimages(newimage);
    }

    //image入れ替え
    const onImageSortEnd = ({ oldIndex, newIndex }) => {
        let newimage = arrayMove(images, oldIndex, newIndex);
        setimages(newimage);
        dispatch(setimagelist(newimage));
    };
    function shouldCancelImage(e) {
        //Image以外ソート不可
        if (e.target.className !== 'image') return true;
    }

    //画像
    const SortableImageItem = SortableElement(({ index, image }) => (
        <div style={{ display: 'inline-block', width: 150, margin: 5, verticalAlign: 'top', position: 'relative' }}>
            <div style={{ width: 150 }}>
                <InputBase
                    style={{ width: 110 }} title={image.filename}
                    value={image.filename}
                />
                {formstatus==='ENTRY FORM'?
                <IconButton size="small" title="画像ダウンロード" onClick={() => imagedownload(image.filename)}>
                    <Icon style={{ fontSize: 16 }}>file_download</Icon>
                    </IconButton>
                    : <span style={{ marginLeft:22 }}></span>}
                {formlock ? null :
                    <IconButton size="small" title="画像削除" onClick={() => imagedelete(image.filename)}>
                        <Icon style={{ fontSize: 16 }}>delete</Icon>
                    </IconButton>
                }
            </div>
            <img src={image.imageurl} alt={image.filename} className='image'
                onDoubleClick={(e) => ImageDialog(image)}
                style={{ width: 150, height: 150, objectFit: 'cover', padding: 5, border: '1px solid #ccc', cursor: 'move' }}
            />
            <div>
                {kindlist.length === 0 ? null :
                    <TextField
                        id={"kind_" + image.filename}
                        select
                        hiddenLabel
                        value={image.kind ?? ""}
                        onChange={(e)=>imagekindChange(e,image)}
                        variant="standard"
                        size="small"
                        style={{ width: 150 }}
                        inputProps={{ style: { fontSize: 12 } }}
                    >
                        {kindlist.map((option) => (
                            <MenuItem key={option.value} value={option.value} style={{ fontSize: 12 }}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                }
                <div>
                    <TextareaAutosize
                        id={image.filename}
                        readOnly={formlock}
                        value={image.note ?? ""}
                        onChange={(e) => imagenoteChange(e, image)}
                        style={{ width: 150 }}
                    />
                </div>
            </div>
        </div>
    ));
    const SortableImageList = SortableContainer(({ items }) => {
        return (
            <div style={{ width: '100%', whiteSpace: 'nowrap', overflowX: 'auto', overflowY: 'none' }}>
                {items.map((value, index) => (
                    <SortableImageItem
                        key={value.fullname ?? value.filename ?? `item-${index}`}
                        index={index}
                        image={value}
                    />
                ))}
            </div>
        );
    });

    return (
        <div id="imagepanel">
            <SortableImageList
                axis={"x"}
                items={images}
                onSortEnd={onImageSortEnd}
                distance={2}
                shouldCancelStart={shouldCancelImage} />
        </div >
    )

}
